module.exports = __webpack_public_path__ + "img/video.81343b91.png";